export default {
  countryAreasRequireCities: {
    validate(value) {
      return value.every(country_area => country_area.cities && country_area.cities.length > 0);
    },
    message: (fieldName) => {
      return `O campo ${fieldName} contêm distritos que não possuem concelhos selecionados`;
    }
  },
};